<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户PO</label>
            <span class="weui-form-preview__value">{{initData.sa_pocode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户名称</label>
            <span class="weui-form-preview__value">{{initData.sa_custname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币种</label>
            <span class="weui-form-preview__value">{{initData.sa_currency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">付款方式</label>
            <span class="weui-form-preview__value">{{initData.sa_payments}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">联系人</label>
            <span class="weui-form-preview__value">{{initData.sa_custcontact}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">收货地址</label>
            <span class="weui-form-preview__value">{{initData.sa_toplace}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">下单日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.sa_date}}</span>
          </div>
          <!-- <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">关联销售单号</label>
            <span class="weui-form-preview__value">{{initData.sa_detno}}</span>
          </div> -->
        </div>
      </div>
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd form-detail-preview" v-for="(item, index) in initData.orderDetails" :key="item.sd_detno">
          <div class="form-detail-preview_num">{{ item.sd_detno }}</div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户物料编号</label>
            <span class="weui-form-preview__value">{{item.sd_custprodcode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">变更日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.saleChangeDTO.sc_change_time}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{item.sd_custproddetail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{item.sd_custorispeccode}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.productDTO">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{item.productDTO.pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <span class="weui-form-preview__value">{{item.sd_custprodbrand}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{item.sd_custprodspec}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.saleChangeDTO">
            <label class="weui-form-preview__label">变更前数量</label>
            <span class="weui-form-preview__value">{{item.saleChangeDTO.sc_qty_old}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.saleChangeDTO">
            <label class="weui-form-preview__label">变更后数量</label>
            <span class="weui-form-preview__value">{{item.saleChangeDTO.sc_qty_new}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.saleChangeDTO">
            <label class="weui-form-preview__label">变更前含税单价（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.saleChangeDTO.sc_price_old}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.saleChangeDTO">
            <label class="weui-form-preview__label">变更后含税单价（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.saleChangeDTO.sc_price_new}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.saleChangeDTO">
            <label class="weui-form-preview__label">变更前税率</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.saleChangeDTO.sc_taxrate_old}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.saleChangeDTO">
            <label class="weui-form-preview__label">变更后税率</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.saleChangeDTO.sc_taxrate_new}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.saleChangeDTO">
            <label class="weui-form-preview__label">变更前交货日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.saleChangeDTO.sc_delivery_old}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="item.saleChangeDTO">
            <label class="weui-form-preview__label">变更后交货日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.saleChangeDTO.sc_delivery_new}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label" v-if="item.saleChangeDTO">变更前价税合计（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.saleChangeDTO.sc_total_old}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label" v-if="item.saleChangeDTO">变更后价税合计（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{item.saleChangeDTO.sc_total_new}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label"></label>
            <div class="weui-form-preview__value text-link">
              <span @click="onConfirm(item, index)">确认√</span>
              <span style="margin-left: 40px;" v-if="item.sd_confirm" @click="onOpenReject(index)">拒绝×</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showRejectInput">
      <div class="weui-mask weui-transition"></div>
      <div class="weui-half-screen-dialog weui-transition">
        <div class="weui-half-screen-dialog__hd">
          <div class="weui-half-screen-dialog__hd__main">
            <div class="weui-half-screen-dialog__title">拒绝原因</div>
            <!-- <div class="weui-half-screen-dialog__subtitle">{{ subtitle }}</div> -->
          </div>
        </div>
        <div
          class="weui-half-screen-dialog__bd"
          style="padding-top: 12px; height: 150px"
        >
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              rows="5"
              autofocus
              v-model="rejectReason"
              placeholder="请填写......"
              placeholder-class="weui-input__placeholder"
            />
          </div>
        </div>
        <div class="weui-half-screen-dialog__ft">
          <div class="weui-half-screen-dialog__btn-area">
            <div class="weui-btn weui-btn_primary" @click="onReject">确认</div>
            <div class="weui-btn weui-btn_default" @click="onCancelReject">取消</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  },
  data() {
    return {
      showRejectInput: false,
      rejectReason: ""
    }
  },
  methods: {
    onConfirm(item, index) {
      if(index > 0) {
        this.$weui.topTips("请按顺序变更", 2000)
        return
      }

      let me = this

      let jsonData = {
        category: 20,
        fromChangeId: item.saleChangeDTO.id,
        sdid: item.sd_id
      }

      me.$loading({
        url: "/api/sale/b2bPortal/confirmChange",
        method: "POST",
        jsonData
      }).then(function (res) {
        if (res.success) {
          me.$weui.toast("已确认成功", 2000);
          me.$router.back()
          // me.tempRejectIndex = undefined
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    },
    onOpenReject(index) {
      if(index > 0) {
        this.$weui.topTips("请按顺序变更", 2000)
        return
      }

      this.showRejectInput = true
      this.tempRejectIndex = index
    },
    onReject() {
      let me = this,
        index = me.tempRejectIndex,
        item = me.initData.orderDetails[index]

      let jsonData = {
        custid: item.sd_custid,
        custuu: item.sd_customeruu,
        fromCode: item.saleChangeDTO.sc_code,
        fromMainId: item.saleChangeDTO.id,
        fromType: "MakeChange",
        reason: me.rejectReason
      }

      me.$loading({
        url: "/api/sale/saledown/reject",
        method: "POST",
        jsonData
      }).then(function (res) {
        if (res.success) {
          me.$weui.toast("已拒绝", 2000);
          me.$router.back()
          // me.tempRejectIndex = undefined
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    },
    onCancelReject() {
      this.showRejectInput = false
      this.tempRejectIndex = undefined
    }
  },
};
</script>